export function templatesFn() {
    const { $t } = useLocalization();

    return [
        {
            title: '1/3 - 2/3',
            description: $t('[[[Wstaw dwie kolumny 1/3 oraz 2/3]]]'),
            content: `
            <div class="template-grid template-grid-1-2">
                <div>
                    Kolumna 33%
                </div>
                <div>
                    Kolumna 66%
                </div>
            </div>
            <p></p>
        `
        },
        {
            title: '2/3 - 1/3',
            description: $t('[[[Wstaw dwie kolumny 2/3 oraz 1/3]]]'),
            content: `
            <div class="template-grid template-grid-2-1">
                <div>
                    Kolumna 66%
                </div>
                <div>
                    Kolumna 33%
                </div>
            </div>
            <p></p>
        `
        },
        {
            title: '1/2',
            description: $t('[[[Wstaw dwie równe kolumny]]]'),
            content: `
            <div class="template-grid template-grid-1-1">
                <div>
                    Kolumna 50%
                </div>
                <div>
                    Kolumna 50%
                </div>
            </div>
            <p></p>
        `
        },
        {
            title: '1/3',
            description: $t('[[[Wstaw trzy kolumny 1/3]]]'),
            content: `
            <div class="template-grid template-grid-1-1-1">
                <div>
                    Kolumna 33%
                </div>
                <div>
                    Kolumna 33%
                </div>
                <div>
                    Kolumna 33%
                </div>
            </div>
            <p></p>
        `
        },
        {
            title: '1/4',
            description: $t('[[[Wstaw cztery kolumny 1/4]]]'),
            content: `
            <div class="template-grid template-grid-1-1-1-1">
                <div>
                    Kolumna 25%
                </div>
                <div>
                    Kolumna 25%
                </div>
                <div>
                    Kolumna 25%
                </div>
                <div>
                    Kolumna 25%
                </div>
            </div>
            <p></p>
        `
        },
        {
            title: $t('[[[Ważne informacje]]]'),
            description: $t('[[[Wstaw szablon informacyjny ze zdjęciem]]]'),
            content: `
            <div class="template-grid template-grid-1-3 custom-template">
                <div class="image-template">
                    <img src="/static/img/logo.png">
                </div>
                <div class="desc">
                    Treść komunikatu
                </div>
            </div>
            <p></p>
        `
        }
    ];
}
